module.exports = __webpack_public_path__ + "static/contactlens-ed6b98e5dd6ba9c42819e433913634ad.jpg";